/* eslint-disable react/no-unstable-nested-components */
import React from "react";
import {
    CaretDownOutlined, MedicineBoxOutlined, ShopOutlined, ShoppingCartOutlined, UsergroupAddOutlined
} from "@ant-design/icons";
import { Collapse, Radio, Empty } from "antd";
import MarketPackageSkeleton from "./MarketPackageSkeleton";
import { getModuleName } from "../../../utils/oneintelligence/OneIntelligenceHelper";

const { Panel } = Collapse;

const getIconDefault = (code) => { //  get MP icon
    switch (code) {
        case "healthcaredev":
        case "healthcare": return <MedicineBoxOutlined className="c-bg-400" />;
        case "brandandinsightsdev":
        case "brandandinsights": return <UsergroupAddOutlined className="c-bg-400" />;
        case "b2bdev":
        case "b2b": return <ShopOutlined className="c-bg-400" />;
        case "enterprisedev":
        case "enterprise": return <ShoppingCartOutlined className="c-bg-400" />;
        default: return <ShopOutlined className="c-bg-400" />;
    }
};

const MarketPackageList = function ({
    marketPackages = [],
    loading,
    loadingItemCount,
    activeKey = [],
    selected,
    className,
    setSelected = () => { },
    setActiveKey = () => { },
    getIcon = getIconDefault,
    loadingElement,
    emptyElement,
    renderItem,
    collapseProps = {}
}) {
    const renderPanel = (mp) => {
        if (renderItem) {
            return renderItem(mp);
        }
        const { description, key, children, code } = mp;
        const getName = (obj) => obj.title || obj.name;
        const isAvailable = (obj) => obj.available || obj.isAvailable;
        return (
            <Panel
                collapsible={isAvailable(mp) === false ? "disabled" : ""}
                key={key || code}
                header={(
                    <div className="marketPackage_item_header">
                        <div className="marketPackage_item_icon">{getIcon(code)}</div>
                        <div className="marketPackage_item_text">
                            {isAvailable(mp) === false ? (
                                <div className="marketPackage_container_disabled_container">
                                    <div className="disabled_title">{getName(mp)}</div>
                                    <div className="disabled_avaiable">Available soon</div>
                                </div>
                            ) : <div className="marketPackage_item_text_title">{getName(mp)}</div>}
                            <div className="marketPackage_item_text_desc">{description}</div>
                        </div>
                    </div>
                )}
                className="marketPackage_item"
            >
                <p className="marketPackage_item_module_label">Select module</p>
                <Radio.Group
                    onChange={(e) => {
                        setSelected(e, {
                            ...mp?.children?.find((c) => c.code === e.target.value) || {},
                            parent: mp
                        });
                    }}
                    value={selected?.code || ""}
                >
                    <div className="marketPackage_item_module_container">
                        {children.map((child) => child.isActive ?
                            <Radio key={child.key} value={child.code} disabled={isAvailable(child) === false}>
                                {isAvailable(child) === false ? (
                                    <div className="marketPackage_container_disabled_container">
                                        <div className="disabled_title">{getModuleName(child)}</div>
                                        <div className="disabled_avaiable">Available soon</div>
                                    </div>
                                ) : <div className="marketPackage_item_text_title">{getModuleName(child)}</div>}
                                <div className="marketPackage_item_text_desc">
                                    {child.description}
                                </div>
                            </Radio>
                            : null)}
                    </div>
                </Radio.Group>
            </Panel>
        );
    };
    const expandIcon = ({ isActive }) => (
        <CaretDownOutlined
            className="marketPackage_container_expanded_icon"
            rotate={isActive ? 180 : 0}
            width={20}
            height={20}
        />
    );

    const getContent = () => {
        let elem = null
        if (loading) {
            elem = (loadingElement || <MarketPackageSkeleton count={loadingItemCount} />)
        }
        if (!marketPackages.length) {
            return (emptyElement || <Empty
                className="marketPackage_empty"
                description={<span style={{ whiteSpace: "pre-wrap" }}>No Market Package Access.</span>}
            />)
        }
        elem = <>
            {marketPackages.map((mp) => renderPanel(mp))}
        </>

        return <Collapse
            bordered={false}
            accordion
            onChange={setActiveKey}
            activeKey={activeKey}
            expandIcon={expandIcon}
            expandIconPosition="end"
            className={`marketPackage_container ${className}`}
            {...collapseProps}
        >
            {elem}
        </Collapse>
    }

    return getContent();
};

export default MarketPackageList;
